import Label from 'components/Filters/FilterPanel/subcomponents/SubButtons/subcomponents/SubButton/Label'
import Selector from 'components/Filters/FilterPanel/subcomponents/SubButtons/subcomponents/SubButton/Selector'
import SelectorFromTo from 'components/Filters/FilterPanel/subcomponents/SubButtons/subcomponents/SubButton/SelectorFromTo'
import Datepicker from 'components/Filters/FilterPanel/subcomponents/SubButtons/subcomponents/SubButton/Datepicker'
import Switcher from 'components/Filters/FilterPanel/subcomponents/SubButtons/subcomponents/SubButton/Switcher'
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useSelector } from 'react-redux'

const SUBBUTTONS_MAP = {
  input: Label,
  'checkbox group': Selector,
  'checkbox selector': Selector,
  'radio group': Selector,
  datepicker: Datepicker,
  switcher: Switcher,
  select: Label,
  'from-to selector': SelectorFromTo,
}

const SubButton = ({ filterManager, filterKey }) => {
  const { configuration } = filterManager
  const breakpoints = useBreakpoint()
  const { i18n } = useSelector(({ app }) => app)

  const El = useMemo(
    () => SUBBUTTONS_MAP[configuration[filterKey].type],
    [i18n, filterKey, configuration],
  )

  return El ? (
    <El
      filterManager={filterManager}
      filterKey={filterKey}
      breakpoints={breakpoints}
    />
  ) : null
}

SubButton.propTypes = {
  filterManager: PropTypes.object,
  filterKey: PropTypes.string,
}

export default SubButton
